<div class="drill-down-main-container">
    <div class="categories-main-container">
        <div class="carousel-btn-container"
            (click)="prevCarouselPage()">
            <div class="previous-button carousel-btn">
                <i class="bi bi-chevron-left"></i>
            </div>
            <span>{{'drill_down_previous_button' | translate}}</span>
        </div>
        <p-carousel
            *ngIf="categoryList.length"
            #carousel
            [value]="categoryList"
            [page]="pageOfCurrentCategory"
            [numVisible]="1"
            [numScroll]="1"
            [showIndicators]="false"
            [showNavigators]="false"
            [circular]="true"
            (onPage)="changeCategoryPage($event)">
            <ng-template pTemplate="item" let-item>
                <div class="category-carousel-main-item-container">
                    <div class="category-carousel-item">
                        <div class="category-icon-container" [ngStyle]="{'background-color':item.color}">
                            <app-dinamic-indicator-display
                                [indicatorName]="item.icon" [color]="'#FFFFFF'"></app-dinamic-indicator-display>
                        </div>
                        <span class="category-name">{{item.title}}</span>
                        <div class="category-value-container">
                            <span class="category-value">{{item.score}}</span>
                            <span class="category-percentage">%</span>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
        <div class="carousel-btn-container"
            (click)="nextCarouselPage()">
            <span>{{'drill_down_next_button' | translate}}</span>
            <div class="next-button carousel-btn">
                <i class="bi bi-chevron-right"></i>
            </div>
        </div>
    </div>
    <div class="statements-main-container">
        <h2>{{'drill_down_feedback_behind_indicator' | translate}}</h2>
        <div class="filters-container">
            <p-dropdown
                class="sort-by-dropdown"
                [(ngModel)]="activeSorting"
                [options]="sortingByIndicators"
                optionLabel="name"
                placeholder="{{'drill_down_sort_by_label' | translate}}"
                dropdownIcon="bi bi-caret-down-fill"
                (onChange)="changeSorting()"
                (keydown.enter)="$event.preventDefault();$event.stopPropagation()">
            </p-dropdown>
        </div>
        <div class="statements-container">
            <div class="statement-container" *ngFor="let statement of statementData?.statements, let index = index">
                <p-accordion
                    (onOpen)="emitStatementResponses(statement.question.type, statement?.projectTimedQuestionCollection, statement.question.uuid, index)"
                    collapseIcon="bi bi-chevron-up" expandIcon="bi bi-chevron-down">
                    <p-accordionTab [selected]="showSelectedTabState[index]">
                        <ng-template pTemplate="header">
                            <img *ngIf="statement.question.type !== 'open'" src="../../../../../assets/svg/statement-icon-{{statement?.question?.color}}.svg">
                            <h2 class="statement-title" [innerHTML]="statement.question.title"></h2>
                            <div *ngIf="statement.projectTimedQuestionCollection" class="question-container-category">
                                <span class="question-category-title">{{statement?.projectTimedQuestionCollection?.questionCollection.title}}</span>
                            </div>
                        </ng-template>
                        <ng-template *ngIf="statement.question.type === 'scaled'" pTemplate="content">
                            <app-scaled-question-distribution 
                                [responseDistributionObs]="responseDistribution">
                            </app-scaled-question-distribution>
                        </ng-template>
                        <ng-template *ngIf="statement.question.type === 'ranked'" pTemplate="content">
                            <div class="rated-question-container">
                                <h4 style="margin-bottom: 0;">Your average rating for the project in this check-in is:</h4>
                                <div class="rated-question-rating-container">
                                    <h4 class="rating-value-text">{{statement.question.rating}}</h4>
                                    <h4 class="rating-text">Rating</h4>
                                </div>
                            </div>
                        </ng-template>
                    </p-accordionTab>
                </p-accordion>
            </div>
        </div>
        <p-paginator [first]="activePage" [rows]="1" [totalRecords]="statementData?.pageCount" (onPageChange)="changeStatementsPage($event)"></p-paginator>
    </div>
</div>
